import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Heading from "@/components/core/Heading/Heading"
import SwatchItems from "@/components/PartsViewer/v2/SwatchItems"
import Style from "@/components/VisualSearch/v1/ResultPage/ProductDtls/index.module.scss"
import Button from "@/components/core/Button/Button"
import { getTranslations } from "@/components/VisualSearch/localization"
import { useTranslation } from "next-i18next"
import {
  formatPrice,
  getPrice,
  getScrollTo,
  viewPdp,
} from "@/components/VisualSearch/v1/utils"
import { getUserPersona } from "@/utils/helper"

const ProductDtls = props => {
  const { product, setVarentList, varentList, setShow } = props

  const { allswatch } = product || {}
  const [varent, setVarent] = useState(product.sku)
  const { t } = useTranslation()
  const {
    colorFinish,
    closestMatch,
    friendsFamilyPrice,
    associatePrice,
    listPriceInfo,
  } = getTranslations(t)
  const persona = getUserPersona()

  useEffect(() => {
    setVarent(product.sku)
  }, [product.sku])

  useEffect(() => {
    allswatch[0].filter(item => {
      if (item?.id === varent) {
        setVarentList(item)
      }
    })
  }, [varent])
  const handleSwatchClick = selectedVarent => {
    const viewport = window.innerWidth
    if (viewport < 812) {
      getScrollTo(`image_${selectedVarent}`)
    }
  }

  const priceCTR = varentList?.prices?.prices?.[persona]?.centAmount
  const discountPrice =
    varentList?.prices?.discountPrices?.[persona]?.centAmount
  const pricing = getPrice(priceCTR, discountPrice)
  const personaPrice = varentList?.prices?.prices?.[persona]

  return (
    <div className={`${Style.DetailsProduct}`}>
      <div className="details-text" id="details-text">
        <p className={"closest-match"}>{closestMatch}</p>
        <Heading level={2} className="label-desc mt-1 text-capitalize">
          {product?.name}
        </Heading>
        <Heading level={3} className="label-sku">
          {product?.shortDescription}
        </Heading>
        <Heading level={3} className="label-sku-number">
          {varentList?.sku ?? product?.sku}
        </Heading>
        {personaPrice !== undefined ? (
          <>
            <Heading level={3} className="label-price">
              {pricing?.actualPrice}
              {persona === "KEMP" || persona === "FF" ? (
                <p className="productdtlpage__customer-group">
                  {persona === "FF" ? <span>{friendsFamilyPrice}</span> : null}
                  {persona === "KEMP" ? <span>{associatePrice}</span> : null}
                </p>
              ) : null}
            </Heading>
            <Heading level={3} className="label-price-strike">
              <strike>{pricing?.strikePrice}</strike>
            </Heading>
            <p className="pricelist-text">
              {formatPrice(varentList?.prices?.prices?.["ANY"]?.centAmount)}
              <span className="list-text ml-5 ">
                <span>List Price</span>
                <span className="list-description">{listPriceInfo}</span>
              </span>
            </p>
          </>
        ) : null}

        <p className=" text-color ">
          <span className="color-finish">{colorFinish} </span>
          <span className="finish">{varentList?.label ?? product?.label}</span>
        </p>
        <SwatchItems
          variantList={allswatch[0]}
          setVariant={setVarent}
          variant={varent}
          clickSwatch={() => handleSwatchClick(varentList?.sku)}
        />
        <div className="view-button">
          <Button
            className="view-product-button"
            type="black"
            label="View Product"
            size="large"
            flexible={true}
            role="button"
            onClick={() => viewPdp(product?.pdpUrl)}
          />
          <Button
            className="service-button"
            type="ghost"
            label="Service Parts"
            size="large"
            flexible={true}
            role="button"
            onClick={() => {
              setShow(true)
            }}
          />
        </div>
      </div>
    </div>
  )
}

ProductDtls.propTypes = {
  product: PropTypes.shape({
    sku: PropTypes.string,
    productNo: PropTypes.string,
    name: PropTypes.string,
    shortDescription: PropTypes.string,
    label: PropTypes.string,
    pdpUrl: PropTypes.string,
    allswatch: PropTypes.arrayOf(PropTypes.array),
  }),
  setVarentList: PropTypes.func.isRequired,
  varentList: PropTypes.shape({
    sku: PropTypes.string,
    label: PropTypes.string,
    prices: PropTypes.shape({
      prices: PropTypes.objectOf(
        PropTypes.shape({
          centAmount: PropTypes.number,
        })
      ),
      discountPrices: PropTypes.objectOf(
        PropTypes.shape({
          centAmount: PropTypes.number,
        })
      ),
    }),
  }),
  setShow: PropTypes.func.isRequired,
}

export default ProductDtls
